/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { compose, withStateHandlers, lifecycle, withProps } from 'recompose';

import { on, off } from 'utils/dom/dom';

import { Button } from 'components/core/Button';
import { SFIcon } from 'components/core/SFIcon';
import { FacilityCard } from 'components/search/FacilityCard';

export const enhance = compose(
	withStateHandlers({ mouseIsDownOnCard: false }, {
		handleMouseDown: () => () => ({ mouseIsDownOnCard: true }),
		handleMouseUp: () => () => ({ mouseIsDownOnCard: false }),
		handleClick: ({ mouseIsDownOnCard }, { onClickOutside }) => (e) => {
			if (!mouseIsDownOnCard) {
				onClickOutside(e);
			}
		},
		handleCloseClick: (_, { onClickOutside }) => (e) => {
			onClickOutside(e);
		}
	}),
	lifecycle({
		componentDidMount() {
			on('mousedown', this.props.handleClick);
		},
		componentWillUnmount() {
			off('mousedown', this.props.handleClick);
		}
	}),
	withProps(({ facility }) => ({
		facilityUrl: facility.url.facility
	}))
);

export function FacilityInfoContent({
	facility,
	getLocalPhoneNumberByZipCode,
	handleMouseDown,
	handleMouseUp,
	handleCloseClick,
	phone
}) {
	return (
		<div
			className="overlay-content"
			onMouseDown={handleMouseDown}
			onMouseUp={handleMouseUp}
		>
			<Button
				primary={false}
				className="dismiss-icon"
				onClick={handleCloseClick}
			>
				<SFIcon icon="close" />
			</Button>
			<div className="overlay-content-body">
				<div className="fac-info-card">
					<FacilityCard
						facility={facility}
						phone={phone}
						getLocalPhoneNumberByZipCode={getLocalPhoneNumberByZipCode}
						lazyLoad={false}
					/>
				</div>
			</div>
			<div className="overlay-pointer" />
		</div>
	);
}

FacilityInfoContent.propTypes = {
	facility: PropTypes.object,
	getLocalPhoneNumberByZipCode: PropTypes.func,
	handleMouseDown: PropTypes.func,
	handleMouseUp: PropTypes.func,
	handleCloseClick: PropTypes.func,
	phone: PropTypes.object
};

export default enhance(FacilityInfoContent);
